import {
  containsLowercase,
  containsNumber,
  containsSpecialCharacter,
  containsUppercase,
  hasNoLeadingOrTrailingSpaces,
  meetsMinimumLength,
} from '@/utils/validation';

export const validatePassword = (password: string) => {
  const isMinLength = meetsMinimumLength(password, 8);
  const hasUppercase = containsUppercase(password);
  const hasLowercase = containsLowercase(password);
  const hasNumber = containsNumber(password);
  const hasSpecialChar = containsSpecialCharacter(password);
  const noLeadingTrailingSpaces = hasNoLeadingOrTrailingSpaces(password);

  return {
    isMinLength,
    hasUppercase,
    hasLowercase,
    hasNumber,
    hasSpecialChar,
    noLeadingTrailingSpaces,
    isValid: isMinLength && hasUppercase && hasLowercase && hasNumber && hasSpecialChar,
  };
};
